<template>
    <div class="order-management">
        <!-- 订单类型标签页 -->
        <el-tabs type="border-card" v-model="activeSubTab" @tab-click="handleSubTabChange" class="sub-tabs">
            <el-tab-pane label="零散订单" name="internal"></el-tab-pane>
            <el-tab-pane label="小程序订单" name="miniProgram"></el-tab-pane>
            <el-tab-pane label="内部订单" name="inner"></el-tab-pane>
        </el-tabs>

        <!-- 筛选搜索区域 -->
        <el-card class="filter-card">
            <el-form :inline="true" :model="filterForm" class="filter-form" size="mini">
                <el-form-item label="订单编号">
                    <el-input v-model="filterForm.orderNumber" placeholder="请输入订单编号" clearable size="mini"></el-input>
                </el-form-item>
                <el-form-item label="客户名称" v-if="activeSubTab === 'miniProgram'">
                    <el-input v-model="filterForm.customerName" placeholder="请输入客户名称" clearable size="mini"></el-input>
                </el-form-item>
                <el-form-item label="下单人" v-if="activeSubTab === 'inner'">
                    <el-input v-model="filterForm.creatorName" placeholder="请输入下单人" clearable size="mini"></el-input>
                </el-form-item>
                <el-form-item label="下单人" v-if="activeSubTab === 'internal'">
                    <el-input v-model="filterForm.creatorName" placeholder="请输入下单人" clearable size="mini"></el-input>
                </el-form-item>
                <el-form-item label="订单状态">
                    <el-select v-model="filterForm.status" placeholder="选择订单状态" size="mini">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="待接单" value="0"></el-option>
                        <el-option label="已接单" value="1"></el-option>
                        <el-option label="已取消" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="下单时间">
                    <el-date-picker v-model="filterForm.createTime" type="datetimerange" range-separator="至"
                        start-placeholder="开始时间" end-placeholder="结束时间" size="mini"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="fetchOrders" size="mini">
                        <i class="el-icon-search"></i> 查询
                    </el-button>
                    <el-button @click="resetFilter" size="mini">
                        <i class="el-icon-refresh"></i> 重置
                    </el-button>
                    <el-button type="primary" @click="showCreateInternalOrderDialog">
                        <i class="el-icon-plus"></i> 新增订单
                    </el-button>
                    <el-button size="mini" type="success" icon="el-icon-check" @click="batchAcceptOrders">
                        批量接单
                    </el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <!-- 订单列表 -->
        <el-card class="order-list-card" style="margin-top: 5px;">
            <el-table :data="filteredOrders" border stripe
                style="width: 100% !important; margin-top: 15px; height: 48vh; overflow: auto !important;"
                @row-click="handleRowClick" ref="orderTable" v-loading="loading" element-loading-text="正在加载订单数据..."
                empty-text="暂无订单数据">
                <el-table-column type="selection" width="45"></el-table-column>
                <el-table-column prop="index" label="序号" width="50" align="center"></el-table-column>
                <el-table-column prop="orderNumber" label="订单号" align="center"></el-table-column>
                <el-table-column prop="orderName" label="订单名称" align="center"></el-table-column>
                <el-table-column prop="orderType" label="订单类型" align="center">
                    <template #default="scope">
                        {{ formatOrderType(scope.row.orderType) }}
                    </template>
                </el-table-column>
                <el-table-column prop="customerName" label="客户名称" align="center"></el-table-column>
                <el-table-column prop="customerPhone" label="联系电话" align="center"></el-table-column>
                <el-table-column prop="orderTime" label="下单时间" align="center"></el-table-column>
                <el-table-column prop="harvestDate" label="收货时间" align="center"></el-table-column>

                <el-table-column prop="orderStatus" label="订单状态" align="center">
                    <template #default="scope">
                        <el-tag :type="getStatusTagType(scope.row.orderStatus)">
                            {{ getStatusText(scope.row.orderStatus) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="pickupMethod" label="取货方式" align="center">
                    <template #default="scope">
                        <el-tag :type="getStatusTagType1(scope.row.pickupMethod)">
                            {{ formatPickupMethod(scope.row.pickupMethod) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="totalAmount" label="总价格" align="center">
                    <template #default="scope">
                        ¥{{ scope.row.totalAmount ? scope.row.totalAmount.toFixed(2) : '0.00' }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="490">
                    <template #default="scope">
                        <el-button size="mini" type="primary" @click="showDishDrawer(scope.row)">
                            <i class="el-icon-view"></i> 商品清单
                        </el-button>
                        <el-button size="mini" type="primary" @click="viewOrderDetail(scope.row)">
                            <i class="el-icon-view"></i> 详情
                        </el-button>
                        <el-tooltip v-if="scope.row.orderStatus === 3" content="订单信息未完善，请先完善订单后再接单" placement="top">
                            <el-button size="mini" type="success" icon="el-icon-check" disabled>接单</el-button>
                        </el-tooltip>
                        <el-button v-else-if="scope.row.orderStatus === 0" size="mini" type="success"
                            icon="el-icon-check" @click="acceptOrders(scope.row.id)">接单</el-button>
                        <el-button v-else size="mini" type="success" icon="el-icon-check" disabled>已接单</el-button>
                        <el-button size="mini" type="primary" icon="el-icon-edit"
                            @click="showEditOrderDialog(scope.row)">修改</el-button>
                        <el-button size="mini" type="danger" icon="el-icon-delete"
                            @click="handleDeleteOrder(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="totalOrders" background></el-pagination>
            </div>
        </el-card>

        <!-- 商品清单抽屉 -->
        <el-drawer title="商品管理" :visible.sync="detailDrawerVisible" placement="right" size="80%"
            :close-on-click-modal="false" :append-to-body="true" custom-class="detail-drawer">
            <el-button type="primary" @click="showAddDishDialog" style="margin-bottom: 15px">
                <i class="el-icon-plus"></i> 新增商品
            </el-button>
            <el-table ref="supplierTable" :data="Listdish" border stripe
                :header-cell-style="{ background: '#f5f7fa', fontWeight: 'bold' }" @row-click="handleDishRowClick"
                height="50vh">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="序号" type="index"></el-table-column>
                <el-table-column prop="orderNumber" label="订单编号"></el-table-column>
                <el-table-column prop="productType" label="菜品类型" align="center">
                    <template #default="scope">
                        {{ scope.row.productType === 'finished' ? '成品菜' : '半成品' }}
                    </template>
                </el-table-column>
                <el-table-column prop="productName" label="商品名称">
                    <template #default="scope">
                        {{ scope.row.productName || scope.row.dishName }}
                    </template>
                </el-table-column>
                <el-table-column prop="productCode" label="商品编码" align="center">
                    <template #default="scope">
                        {{ scope.row.productCode || scope.row.dishCode }}
                    </template>
                </el-table-column>
                <el-table-column prop="productPrice" label="商品价格" align="center">
                    <template #default="scope">
                        ¥{{ scope.row.productPrice ? scope.row.productPrice.toFixed(2) : '0.00' }}
                    </template>
                </el-table-column>
                <el-table-column prop="productTime" label="生产时间" align="center"></el-table-column>
                <el-table-column prop="productDescription" label="商品描述" align="center"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template #default="scope">
                        <el-button type="text" size="small" @click="handleEditDish(scope.row)">编辑</el-button>
                        <el-button type="text" size="small" class="text-danger"
                            @click="handleDeleteDish(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-drawer>

        <!-- 商品新增/编辑弹窗（修复v-model绑定 + 生产时间改为时间段选择） -->
        <el-dialog :title="isEditDishMode ? '编辑商品' : '新增商品'" :visible.sync="addDishVisible" width="60%" :z-index="9999"
            append-to-body>
            <el-form :model="dishForm" :rules="dishRules" ref="dishFormRef" label-width="100px">
                <el-form-item label="订单编号" prop="orderNumber">
                    <el-input v-model="dishForm.orderNumber" placeholder="请输入订单编号" readonly></el-input>
                </el-form-item>
                <el-form-item label="菜品类型" prop="productType">
                    <el-select v-model="dishForm.productType" placeholder="选择菜品类型" @change="handleproductTypeChange">
                        <el-option label="成品菜" value="finished"></el-option>
                        <el-option label="半成品" value="semi"></el-option>
                    </el-select>
                </el-form-item>
                <!-- 修复：使用计算属性绑定v-model -->
                <el-form-item label="商品名称" :prop="isEditDishMode ? 'productName' : 'dishName'">
                    <el-select v-model="currentDishName" placeholder="选择商品" @change="handleDishSelect">
                        <el-option v-for="dish in getDishListByType(dishForm.productType)" :key="dish.id"
                            :label="isEditDishMode ? dish.productName : dish.dishName"
                            :value="isEditDishMode ? dish.productName : dish.dishName"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品编码" :prop="isEditDishMode ? 'productCode' : 'dishCode'">
                    <el-input v-model="currentDishCode" placeholder="自动填充" readonly></el-input>
                </el-form-item>
                <el-form-item label="商品价格" prop="productPrice">
                    <el-input-number v-model="dishForm.productPrice" :min="0.01" :step="0.01" controls-position="right"
                        placeholder="0.00"></el-input-number>
                </el-form-item>
                <!-- 生产时间：改为时间范围选择器 -->
                <!-- <el-form-item label="生产时间" prop="productTime">
                    <el-time-picker v-model="dishForm.productTimeRange" type="datetimerange" range-separator="至"
                        format="HH:mm" value-format="HH:mm" placeholder="选择生产时间段" style="width: 100%;"></el-time-picker>
                </el-form-item> -->
                <el-form-item label="生产时间" prop="productTime">
                    <el-time-picker v-model="dishForm.productTimeRange" is-range range-separator="至" format="HH:mm"
                        value-format="HH:mm" placeholder="选择生产时间段" style="width: 100%;"
                        @change="formatDishProductTime"></el-time-picker>
                </el-form-item>
                <el-form-item label="商品描述" prop="productDescription">
                    <el-input v-model="dishForm.productDescription" placeholder="请输入商品描述（选填）"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="addDishVisible = false">取消</el-button>
                <el-button type="primary" @click="submitDishForm">
                    {{ isEditDishMode ? '更新商品' : '新增商品' }}
                </el-button>
            </div>
        </el-dialog>

        <!-- 订单详情弹窗 -->
        <el-dialog title="订单详情" :visible.sync="detailDialogVisible" width="70%" :z-index="3000" append-to-body
            :close-on-click-modal="false">
            <div class="order-detail">
                <div class="detail-header">
                    <div class="order-info">
                        <p><strong>订单编号：</strong>{{ currentOrder.orderNumber }}</p>
                        <p><strong>订单名称：</strong>{{ currentOrder.orderName || '无' }}</p>
                        <p><strong>订单类型：</strong>{{ formatOrderType(currentOrder.orderType) }}</p>
                        <p><strong>下单时间：</strong>{{ currentOrder.orderTime }}</p>
                        <p><strong>收货时间：</strong>{{ currentOrder.harvestDate || '未收货' }}</p>
                        <p v-if="activeSubTab === 'inner' || activeSubTab === 'internal'">
                            <strong>下单人：</strong>{{ currentOrder.creatorName }}
                        </p>
                        <p>
                            <strong>订单状态：</strong>
                            <el-tag :type="getStatusTagType(currentOrder.orderStatus)" size="small">
                                {{ getStatusText(currentOrder.orderStatus) }}
                            </el-tag>
                        </p>
                    </div>
                    <div class="customer-info" v-if="activeSubTab === 'inner' || activeSubTab === 'internal'">
                        <p><strong>客户名称：</strong>{{ currentOrder.customerName }}</p>
                        <p><strong>客户编号：</strong>{{ currentOrder.customerCode || '无' }}</p>
                        <p><strong>客户电话：</strong>{{ currentOrder.customerPhone }}</p>
                        <p><strong>取货方式：</strong>{{ formatPickupMethod(currentOrder.pickupMethod) }}</p>
                        <p><strong>总价格：</strong>¥{{ currentOrder.totalAmount ? currentOrder.totalAmount.toFixed(2) :
                            '0.00' }}
                        </p>
                    </div>
                </div>
                <div class="detail-body">
                    <h3>菜品明细</h3>
                    <el-table :data="currentOrder.orderItems || []" border style="width: 100%; margin-top: 10px">
                        <el-table-column prop="productType" label="菜品类型" align="center">
                            <template #default="scope">
                                {{ scope.row.productType === 'finished' ? '成品菜' : '半成品' }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="productName" label="商品名称" align="center">
                            <template #default="scope">
                                {{ scope.row.productName || scope.row.dishName }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="productCode" label="商品编码" align="center">
                            <template #default="scope">
                                {{ scope.row.productCode || scope.row.dishCode }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="quantity" label="数量" align="center"></el-table-column>
                        <el-table-column prop="productPrice" label="单价" align="center">
                            <template #default="scope">
                                ¥{{ scope.row.productPrice ? scope.row.productPrice.toFixed(2) : '0.00' }}
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="detail-footer">
                    <div class="order-notes">
                        <p><strong>订单备注：</strong>{{ currentOrder.notes || '无' }}</p>
                    </div>
                </div>
            </div>
            <div slot="footer">
                <el-button @click="detailDialogVisible = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 订单新增/编辑弹窗（合并版 + 生产时间改为时间段选择） -->
        <el-dialog :title="isEditOrderMode ? '修改订单' : '新增订单'" :visible.sync="createInternalOrderVisible" width="80%"
            :z-index="3000" append-to-body>
            <el-form :model="internalOrderForm" :rules="internalOrderRules" ref="internalOrderRef" label-width="100px">
                <!-- 基础信息 -->
                <el-form-item label="订单名称" prop="orderName">
                    <el-input v-model="internalOrderForm.orderName" placeholder="例：2024年X月内部订单" size="mini"></el-input>
                </el-form-item>
                <el-form-item label="下单时间" prop="orderTime">
                    <el-date-picker v-model="internalOrderForm.orderTime" type="datetime" placeholder="选择下单时间"
                        style="width: 100%"></el-date-picker>
                </el-form-item>
                <el-form-item label="订单类型" prop="orderType">
                    <el-select v-model="internalOrderForm.orderType" placeholder="选择订单类型">
                        <el-option label="零散" value="零散"></el-option>
                        <el-option label="小程序订单" value="小程序订单"></el-option>
                        <el-option label="内部" value="内部"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="收货时间" prop="harvestDate">
                    <el-date-picker v-model="internalOrderForm.harvestDate" type="datetime" placeholder="选择收货时间"
                        style="width: 100%"></el-date-picker>
                </el-form-item>

                <!-- 客户信息 -->
                <el-form-item label="客户名称" prop="customerName">
                    <el-input v-model="internalOrderForm.customerName" placeholder="例：行政部/财务部" size="mini"></el-input>
                </el-form-item>
                <el-form-item label="客户编号" prop="customerCode">
                    <el-input v-model="internalOrderForm.customerCode" placeholder="例：CUST001" size="mini"></el-input>
                </el-form-item>
                <el-form-item label="客户电话" prop="customerPhone">
                    <el-input v-model="internalOrderForm.customerPhone" placeholder="例：13800138000"
                        size="mini"></el-input>
                </el-form-item>
                <el-form-item label="取货方式" prop="pickupMethod">
                    <el-select v-model="internalOrderForm.pickupMethod" placeholder="选择取货方式">
                        <el-option label="上门自提" value="selfPickup"></el-option>
                        <el-option label="配送" value="internalDelivery"></el-option>
                    </el-select>
                </el-form-item>

                <!-- 价格与明细 -->
                <el-form-item label="总价格" prop="totalAmount">
                    <el-input v-model.number="internalOrderForm.totalAmount" placeholder="0.00"
                        suffix-icon="el-icon-money" readonly disabled>
                    </el-input>
                </el-form-item>

                <el-form-item label="订单明细">
                    <el-table :data="internalOrderForm.orderItems" border style="width: 100%">
                        <el-table-column prop="productType" label="菜品类型" align="center" width="120">
                            <template #default="scope">
                                <el-select v-model="scope.row.productType" placeholder="选择类型"
                                    @change="handleOrderproductTypeChange(scope.row)">
                                    <el-option label="成品菜" value="finished"></el-option>
                                    <el-option label="半成品" value="semi"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column prop="productName" label="商品名称" align="center" width="130">
                            <template #default="scope">
                                <el-select v-model="scope.row.productName" placeholder="选择商品"
                                    @change="handleOrderDishSelect(scope.row)">
                                    <el-option v-for="dish in getDishListByType(scope.row.productType)" :key="dish.id"
                                        :label="dish.productName" :value="dish.productName"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column prop="productCode" label="商品编码" align="center" width="120">
                            <template #default="scope">
                                <el-input v-model="scope.row.productCode" placeholder="自动填充" readonly
                                    size="mini"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="quantity" label="数量" align="center" width="140">
                            <template #default="scope">
                                <el-input-number v-model="scope.row.quantity" :min="1" controls-position="right"
                                    @change="calculateTotalAmount" size="mini"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column prop="productPrice" label="价格" width="140" align="center">
                            <template #default="scope">
                                <el-input v-model="scope.row.productPrice" :min="0.01" :step="0.01"
                                    @change="calculateTotalAmount" size="mini"></el-input>
                            </template>
                        </el-table-column>
                        <!-- 生产时间：改为时间范围选择器 -->
                        <el-table-column prop="productTime" label="生产时间" align="center">
                            <template #default="scope">
                                <el-time-picker is-range v-model="scope.row.productTimeRange" range-separator="至"
                                    start-placeholder="开始时间" end-placeholder="结束时间" format="HH:mm" value-format="HH:mm"
                                    @change="() => formatOrderItemProductTime(scope.row)"></el-time-picker>
                            </template>
                        </el-table-column>
                        <el-table-column prop="productDescription" label="商品描述" align="center">
                            <template #default="scope">
                                <el-input v-model="scope.row.productDescription" placeholder="选填"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center" width="80">
                            <template #default="scope">
                                <el-button size="mini" type="danger" icon="el-icon-delete"
                                    @click="removeDish(scope.$index)"></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-button type="text" @click="addDish" style="margin-top: 10px">
                        <i class="el-icon-plus"></i> 添加菜品
                    </el-button>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="createInternalOrderVisible = false">取消</el-button>
                <el-button type="primary" @click="submitInternalOrder">
                    {{ isEditOrderMode ? '更新订单' : '提交订单' }}
                </el-button>
            </div>
        </el-dialog>

        <!-- 订单操作确认弹窗 -->
        <el-dialog :title="actionDialogTitle" :visible.sync="actionDialogVisible" width="400px"
            :close-on-click-modal="false" :z-index="2000" append-to-body>
            <p>{{ actionDialogContent }}</p>
            <el-form v-if="currentOrder.orderStatus === 0" :model="actionForm" :rules="actionFormRules"
                ref="actionFormRef" label-width="80px">
                <el-form-item label="接单备注" prop="notes">
                    <el-input v-model="actionForm.notes" type="textarea" rows="3" placeholder="请输入接单备注（选填）"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="actionDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmOrderAction">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    add,
    delOrder,
    edit,
    addOrderItem,
    editOrderItem,
    delOrderItem,
    createPurchasePlan,
    createPurchasePlan2,
    getOrderList
} from "@/api/order";
import { getDishList } from "@/api/dish";

export default {
    name: "OrderManagement",
    data() {
        return {
            // 标签页状态
            activeSubTab: "internal",

            // 筛选表单
            filterForm: {
                orderNumber: "",
                customerName: "",
                creatorName: "",
                status: "",
                createTime: []
            },

            // 订单数据
            allOrders: [],
            filteredOrders: [],
            totalOrders: 0,

            // 分页参数
            currentPage: 1,
            pageSize: 10,

            // 加载状态
            loading: false,

            // 弹窗/抽屉控制
            detailDialogVisible: false,
            actionDialogVisible: false,
            createInternalOrderVisible: false,
            detailDrawerVisible: false,
            addDishVisible: false,
            currentOrder: {},

            // 商品相关数据
            Listdish: [],
            dishForm: {
                orderNumber: "",
                productType: "finished",
                // 新增用字段
                dishName: "",
                dishCode: "",
                // 编辑用字段
                productName: "",
                productCode: "",
                productPrice: 0,
                productTime: "", // 最终传给后端的格式："06:00-08:00"
                productTimeRange: [], // 时间选择器的双向绑定值（数组：[开始时间, 结束时间]）
                productDescription: ""
            },
            dishRules: {
                productType: [{ required: true, message: "请选择菜品类型", trigger: "change" }],
                dishName: [{ required: true, message: "请选择商品名称", trigger: "change" }],
                productName: [{ required: true, message: "请选择商品名称", trigger: "change" }],
                dishCode: [{ required: true, message: "商品编码不能为空", trigger: "change" }],
                productCode: [{ required: true, message: "商品编码不能为空", trigger: "change" }],
                productPrice: [
                    { required: true, message: "请输入商品价格", trigger: "blur" },
                    { type: "number", min: 0.01, message: "价格必须大于0", trigger: "blur" }
                ],
                productTime: [{ required: true, message: "请选择生产时间", trigger: "change" }]
            },
            isEditDishMode: false,
            currentDishId: null,

            // 订单编辑模式标记
            isEditOrderMode: false,
            // 操作弹窗内容
            actionDialogTitle: "",
            actionDialogContent: "",
            actionForm: {
                notes: ""
            },
            actionFormRules: {
                notes: [{ max: 200, message: "备注不能超过200个字符", trigger: "blur" }]
            },

            // 订单表单
            internalOrderForm: {
                id: "",
                orderName: "",
                orderTime: new Date(),
                orderType: "",
                outboundNumber: "",
                outboundStatus: "pending",
                outboundTime: null,
                harvestDate: null,
                customerName: "",
                customerCode: "",
                customerPhone: "",
                pickupMethod: "",
                totalAmount: 0,
                orderItems: [
                    {
                        productType: "finished",
                        productName: "",
                        productCode: "",
                        quantity: 1,
                        productPrice: 0,
                        productTime: "", // 最终传给后端的格式："06:00-08:00"
                        productTimeRange: [], // 时间选择器的双向绑定值
                        productDescription: ""
                    }
                ],
                creatorName: "",
                userId: localStorage.getItem("userId"),
                orderStatus: 0
            },

            // 订单表单验证规则
            internalOrderRules: {
                orderName: [{ required: true, message: "请输入订单名称", trigger: "blur" }],
                orderTime: [{ required: true, message: "请选择下单时间", trigger: "change" }],
                orderType: [{ required: true, message: "请选择订单类型", trigger: "change" }],
                outboundStatus: [{ required: true, message: "请选择出库状态", trigger: "change" }],
                customerName: [{ required: true, message: "请输入客户名称", trigger: "blur" }],
                pickupMethod: [{ required: true, message: "请选择取货方式", trigger: "change" }],
                harvestDate: [{ required: true, message: "请选择收货时间", trigger: "change" }]
            },

            // 菜品库（从接口加载）
            dishLibrary: {
                finished: [],
                semi: []
            }
        };
    },
    // 新增计算属性：解决v-model三元表达式报错
    computed: {
        // 商品名称（兼容新增/编辑模式）
        currentDishName: {
            get() {
                return this.isEditDishMode
                    ? this.dishForm.productName
                    : this.dishForm.dishName;
            },
            set(val) {
                if (this.isEditDishMode) {
                    this.dishForm.productName = val;
                } else {
                    this.dishForm.dishName = val;
                }
            }
        },
        // 商品编码（兼容新增/编辑模式）
        currentDishCode: {
            get() {
                return this.isEditDishMode
                    ? this.dishForm.productCode
                    : this.dishForm.dishCode;
            },
            set(val) {
                if (this.isEditDishMode) {
                    this.dishForm.productCode = val;
                } else {
                    this.dishForm.dishCode = val;
                }
            }
        }
    },
    mounted() {
        this.internalOrderForm.creatorName = localStorage.getItem("userName") || "管理员";
        this.fetchOrders();
    },
    created() {
        this.getDishListByTypeAsync("半成品");
        this.getDishListByTypeAsync("成品菜");
    },
    methods: {
        // 异步加载菜品列表（优化版）
        async getDishListByTypeAsync(type) {
            try {
                const response = await getDishList({
                    userId: localStorage.getItem("userId"),
                    type: type
                });
                const key = type === "成品菜" ? "finished" : "semi";
                this.dishLibrary[key] = response.data.map(item => ({
                    id: item.id,
                    // 兼容新增/编辑的不同字段
                    dishName: item.dishName || item.productName,
                    dishCode: item.dishCode || item.productCode,
                    productName: item.productName || item.dishName,
                    productCode: item.productCode || item.dishCode,
                    price: Number(item.price) || 0
                }));
            } catch (error) {
                console.error(`加载${type}菜品失败:`, error);
                this.$message.error(`加载${type}菜品列表失败`);
            }
        },

        // 判断订单是否为内部订单
        isInternalOrder(order) {
            // 方式1：通过订单类型判断
            const internalOrderTypes = ['内部', '内部订单'];
            return internalOrderTypes.includes(order.orderType);

            // 如果需要通过标签页判断，可以使用：
            // return this.activeSubTab === 'inner';
        },

        // 批量接单 - 修改版：内部订单走createPurchasePlan2接口
        async batchAcceptOrders() {
            const selectedOrders = this.$refs.orderTable?.selection || [];
            if (selectedOrders.length === 0) {
                this.$message.warning("请先选择需要接单的订单");
                return;
            }
            const pendingOrders = selectedOrders.filter(order => order.orderStatus === 0);
            if (pendingOrders.length === 0) {
                this.$message.warning("选中的订单中无待接单订单");
                return;
            }

            try {
                // const ids = pendingOrders.map(order => Number(order.id));
                const userId = localStorage.getItem("userId");

                // 分离内部订单和非内部订单
                const internalOrders = pendingOrders.filter(order => this.isInternalOrder(order));
                const normalOrders = pendingOrders.filter(order => !this.isInternalOrder(order));

                let successCount = 0;

                // 处理内部订单
                if (internalOrders.length > 0) {
                    const internalIds = internalOrders.map(order => Number(order.id));
                    const internalResponse = await createPurchasePlan2({
                        userId,
                        ids: internalIds
                    });
                    if (internalResponse.code === 200) {
                        successCount += internalOrders.length;
                        internalOrders.forEach(order => {
                            const index = this.allOrders.findIndex(item => item.id === order.id);
                            if (index !== -1) {
                                this.allOrders[index].orderStatus = 1;
                            }
                        });
                    } else {
                        this.$message.warning(`内部订单接单失败：${internalResponse.message || '未知错误'}`);
                    }
                }

                // 处理普通订单
                if (normalOrders.length > 0) {
                    const normalIds = normalOrders.map(order => Number(order.id));
                    console.log(normalIds);

                    const normalResponse = await createPurchasePlan({
                        userId,
                        ids: normalIds
                    });
                    if (normalResponse.code === 200) {
                        successCount += normalOrders.length;
                        normalOrders.forEach(order => {
                            const index = this.allOrders.findIndex(item => item.id === order.id);
                            if (index !== -1) {
                                this.allOrders[index].orderStatus = 1;
                            }
                        });
                    } else {
                        this.$message.warning(`普通订单接单失败：${normalResponse.message || '未知错误'}`);
                    }
                }

                // 统一提示结果
                if (successCount > 0) {
                    this.$message.success(`批量接单成功，共${successCount}个订单`);
                    this.filterOrders();
                } else {
                    this.$message.error("批量接单失败");
                }

            } catch (error) {
                console.error("批量接单接口异常:", error);
                this.$message.error("网络错误，批量接单失败");
            }
        },

        // 单个接单 - 修改版：内部订单走createPurchasePlan2接口
        async acceptOrders(id) {
            try {
                // 找到对应的订单
                const order = this.allOrders.find(item => item.id === id);
                if (!order) {
                    this.$message.error("未找到该订单");
                    return;
                }

                const userId = localStorage.getItem("userId");
                const ids = [Number(id)];
                let response;

                // 判断是否为内部订单，选择对应的接口
                if (this.isInternalOrder(order)) {
                    response = await createPurchasePlan2({ userId, ids });
                } else {
                    response = await createPurchasePlan({ userId, ids });
                }

                if (response.code === 200) {
                    this.$message.success("接单成功");
                    const orderIndex = this.allOrders.findIndex(order => order.id === id);
                    if (orderIndex !== -1) {
                        this.allOrders[orderIndex].orderStatus = 1;
                        this.filterOrders();
                    }
                } else {
                    this.$message.error("接单失败");
                }
            } catch (error) {
                console.error("接单接口异常:", error);
                this.$message.error("网络错误，接单失败");
            }
        },

        // 订单状态文本映射
        getStatusText(orderStatus) {
            const statusMap = {
                0: "待接单",
                1: "已接单",
                2: "已取消",
                3: "待完善"
            };
            return statusMap[orderStatus] || "未知状态";
        },

        // 订单状态标签颜色映射
        getStatusTagType(orderStatus) {
            const typeMap = {
                0: "warning",
                1: "success",
                2: "danger",
                3: "warning"
            };
            return typeMap[orderStatus] || "default";
        },

        // 获取订单列表
        async fetchOrders() {
            this.loading = true;
            try {
                const tabToOrderTypeMap = {
                    internal: "零散",
                    miniProgram: "小程序订单",
                    inner: "内部"
                };
                const currentOrderType = tabToOrderTypeMap[this.activeSubTab];
                const response = await getOrderList({
                    userId: localStorage.getItem("userId"),
                    orderType: currentOrderType
                });
                if (response.code === 200) {
                    this.allOrders = response.data.map(order => ({
                        ...order,
                        orderStatus: Number(order.orderStatus),
                        orderItems: (order.orderItems || []).map(item => ({
                            ...item,
                            productType: item.productType || "finished",
                            productPrice: Number(item.productPrice) || 0,
                            quantity: Number(item.quantity) || 1,
                            // 后端返回的productTime是"06:00-08:00"格式，拆分给时间选择器
                            productTimeRange: Array.isArray(item.productTimeRange) ? item.productTimeRange : (item.productTime ? item.productTime.split('-') : []),
                            productTime: item.productTime || ""
                        }))
                    }));
                    this.totalOrders = response.data.length || 0;
                    this.filterOrders();
                } else {
                    this.$message.error(`获取${currentOrderType}订单失败：${response.message || "未知错误"}`);
                    this.allOrders = [];
                    this.totalOrders = 0;
                }
            } catch (error) {
                console.error("获取订单失败:", error);
                this.$message.error("获取订单失败，请重试");
                this.allOrders = [];
                this.totalOrders = 0;
            } finally {
                this.loading = false;
            }
        },

        // 筛选订单
        filterOrders() {
            let result = [...this.allOrders];
            // 订单编号筛选
            if (this.filterForm.orderNumber) {
                result = result.filter(order =>
                    order.orderNumber?.includes(this.filterForm.orderNumber.trim())
                );
            }
            // 客户名称筛选（小程序订单）
            if (this.activeSubTab === "miniProgram" && this.filterForm.customerName) {
                result = result.filter(order =>
                    order.customerName?.includes(this.filterForm.customerName.trim())
                );
            }
            // 下单人筛选（零散/内部订单）
            if ((this.activeSubTab === "internal" || this.activeSubTab === "inner") && this.filterForm.creatorName) {
                result = result.filter(order =>
                    order.creatorName?.includes(this.filterForm.creatorName.trim())
                );
            }
            // 订单状态筛选
            if (this.filterForm.status !== "") {
                result = result.filter(order => order.orderStatus === Number(this.filterForm.status));
            }
            // 时间范围筛选
            if (this.filterForm.createTime && this.filterForm.createTime.length === 2) {
                const startTime = new Date(this.filterForm.createTime[0]).getTime();
                const endTime = new Date(this.filterForm.createTime[1]).getTime();
                result = result.filter(order => {
                    const orderTime = new Date(order.orderTime).getTime();
                    return orderTime >= startTime && orderTime <= endTime;
                });
            }
            // 分页处理
            this.totalOrders = result.length;
            this.filteredOrders = result
                .slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
                .map((order, idx) => ({
                    ...order,
                    index: (this.currentPage - 1) * this.pageSize + idx + 1
                }));
        },

        // 重置筛选条件
        resetFilter() {
            this.filterForm = {
                orderNumber: "",
                customerName: "",
                creatorName: "",
                status: "",
                createTime: []
            };
            this.currentPage = 1;
            this.filterOrders();
        },

        // 查看订单详情
        viewOrderDetail(order) {
            this.currentOrder = { ...order };
            this.detailDialogVisible = true;
        },

        // 显示订单编辑弹窗
        showEditOrderDialog(order) {
            this.isEditOrderMode = true;
            const orderCopy = JSON.parse(JSON.stringify(order));
            // 获取菜品库默认值
            const defaultFinishedDish = this.dishLibrary.finished[0] || {};
            const defaultSemiDish = this.dishLibrary.semi[0] || {};

            this.internalOrderForm = {
                ...orderCopy,
                orderTime: order.orderTime ? new Date(order.orderTime) : new Date(),
                outboundTime: order.outboundTime ? new Date(order.outboundTime) : null,
                harvestDate: order.harvestDate ? new Date(order.harvestDate) : new Date(),
                orderStatus: Number(order.orderStatus),
                orderItems: (orderCopy.orderItems || []).map(item => {
                    // 补全空字段的默认值
                    const defaultDish = item.productType === 'semi' ? defaultSemiDish : defaultFinishedDish;
                    return {
                        ...item,
                        productType: item.productType || "finished",
                        productName: item.productName || defaultDish.productName || "",
                        productCode: item.productCode || defaultDish.productCode || "",
                        quantity: Number(item.quantity) || 1,
                        productPrice: Number(item.productPrice) || defaultDish.price || 0,
                        productTimeRange: Array.isArray(item.productTimeRange) ? item.productTimeRange : (item.productTime ? item.productTime.split('-') : ["00:00", "01:00"]),
                        productDescription: item.productDescription || "",
                        productTime: item.productTime || "00:00-01:00"
                    }
                })
            };
            // 编辑后自动格式化生产时间
            this.internalOrderForm.orderItems.forEach(row => {
                this.formatOrderItemProductTime(row);
            });
            this.calculateTotalAmount();
            this.createInternalOrderVisible = true;
        },

        // 显示新增订单弹窗
        showCreateInternalOrderDialog() {
            this.isEditOrderMode = false;
            const now = new Date();
            const tomorrow = new Date(now.getTime() + 86400000);
            const dateStr = this.formatDateFororderNumber(now);
            const outboundNumber = `OUT${dateStr}${Math.floor(Math.random() * 1000).toString().padStart(3, "0")}`;

            // 初始化时自动选择第一个菜品（如果菜品库有数据）
            const defaultDish = this.dishLibrary.finished[0] || {};

            this.internalOrderForm = {
                id: "",
                orderName: "",
                orderTime: now,
                orderType: "",
                outboundNumber: outboundNumber,
                outboundStatus: "",
                outboundTime: "",
                harvestDate: tomorrow,
                customerName: "",
                customerCode: "",
                customerPhone: "",
                pickupMethod: "",
                totalAmount: 0,
                orderItems: [
                    {
                        productType: "finished", // 类型默认选“成品菜”
                        productName: defaultDish.productName || "", // 关联第一个菜品名称
                        productCode: defaultDish.productCode || "", // 关联第一个菜品编码
                        quantity: 1, // 数量默认1
                        productPrice: defaultDish.price || 0, // 关联第一个菜品价格
                        productTime: "00:00-01:00", // 默认生产时间
                        productTimeRange: ["00:00", "01:00"], // 默认时间范围
                        productDescription: ""
                    }
                ],
                creatorName: localStorage.getItem("userName") || "管理员",
                userId: localStorage.getItem("userId"),
                orderStatus: 0
            };
            // 初始化后自动格式化生产时间（避免空值）
            this.internalOrderForm.orderItems.forEach(row => {
                this.formatOrderItemProductTime(row);
            });
            this.createInternalOrderVisible = true;
        },

        // 删除订单
        async handleDeleteOrder(order) {
            try {
                await this.$confirm(
                    `确定要删除订单【${order.orderNumber}】吗？`,
                    "删除确认",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }
                );
                const response = await delOrder({ id: order.id });
                if (response.code === 200) {
                    this.$message.success("订单删除成功");
                    this.allOrders = this.allOrders.filter(item => item.id !== order.id);
                    this.filterOrders();
                } else {
                    this.$message.error(`删除失败：${response.message || "未知错误"}`);
                }
            } catch (error) {
                if (error !== "cancel") {
                    console.error("删除订单失败:", error);
                    this.$message.error("网络错误，删除失败");
                }
            }
        },

        // 处理订单操作
        handleOrderAction(order) {
            this.currentOrder = { ...order };
            this.actionForm.notes = "";
            switch (order.orderStatus) {
                case 0:
                    this.actionDialogTitle = "确认接单";
                    this.actionDialogContent = "确定要接此订单吗？";
                    break;
                case 1:
                    this.actionDialogTitle = "取消订单";
                    this.actionDialogContent = "确定要取消此订单吗？";
                    break;
            }
            this.actionDialogVisible = true;
        },

        // 确认订单操作
        async confirmOrderAction() {
            if (this.currentOrder.orderStatus === 0) {
                try {
                    await this.$refs.actionFormRef.validate();
                    await this.executeAction();
                } catch (error) {
                    return;
                }
            } else {
                await this.executeAction();
            }
        },

        // 执行订单操作
        async executeAction() {
            try {
                const updatedStatus = this.currentOrder.orderStatus === 0 ? 1 : 2;
                const response = await edit({
                    id: this.currentOrder.id,
                    orderStatus: updatedStatus,
                    notes: this.actionForm.notes || this.currentOrder.notes
                });
                if (response.code === 200) {
                    const index = this.allOrders.findIndex(order => order.id === this.currentOrder.id);
                    if (index !== -1) {
                        this.allOrders[index].orderStatus = updatedStatus;
                        this.allOrders[index].notes = this.actionForm.notes || this.currentOrder.notes;
                    }
                    this.$message.success(updatedStatus === 1 ? "接单成功" : "订单已取消");
                    this.actionDialogVisible = false;
                    this.filterOrders();
                } else {
                    this.$message.error(`操作失败：${response.message || "未知错误"}`);
                }
            } catch (error) {
                console.error("订单操作失败:", error);
                this.$message.error("网络错误，操作失败");
            }
        },

        // 商品清单抽屉
        showDishDrawer(order) {
            if (!order || !order.orderItems || order.orderItems.length === 0) {
                this.$message.warning("该订单暂无商品数据");
                return;
            }
            this.currentOrder = { ...order };
            this.Listdish = order.orderItems.map((dish, idx) => ({
                id: `dish-${order.id}-${idx}`,
                orderNumber: order.orderNumber,
                productType: dish.productType || "finished",
                dishName: dish.dishName,
                dishCode: dish.dishCode,
                productName: dish.productName,
                productCode: dish.productCode,
                productPrice: Number(dish.productPrice) || 0,
                productTime: dish.productTime || "",
                // 后端返回的productTime是"06:00-08:00"格式，拆分给时间选择器
                productTimeRange: Array.isArray(dish.productTimeRange) ? dish.productTimeRange : (dish.productTime ? dish.productTime.split('-') : []),
                productDescription: dish.productDescription || ""
            }));
            this.detailDrawerVisible = true;
        },

        // 打开商品新增弹窗
        showAddDishDialog() {
            this.isEditDishMode = false;
            this.currentDishId = null;
            this.dishForm = {
                orderNumber: this.currentOrder.orderNumber,
                productType: "finished",
                dishName: "",
                dishCode: "",
                productName: "",
                productCode: "",
                productPrice: 0,
                productTime: "",
                productTimeRange: [],
                productDescription: ""
            };
            this.addDishVisible = true;
        },

        // 编辑商品
        // handleEditDish(row) {
        //     this.isEditDishMode = true;
        //     this.currentDishId = row.id;
        //     this.dishForm = {
        //         orderNumber: this.currentOrder.orderNumber,
        //         productType: row.productType || "finished",
        //         dishName: "",
        //         dishCode: "",
        //         productName: row.productName || row.dishName,
        //         productCode: row.productCode || row.dishCode,
        //         productPrice: Number(row.productPrice) || 0,
        //         productTime: row.productTime || "",
        //         // 后端返回的productTime是"06:00-08:00"格式，拆分给时间选择器
        //         productTimeRange: Array.isArray(row.productTimeRange) ? row.productTimeRange : (row.productTime ? row.productTime.split('-') : []),
        //         productDescription: row.productDescription || ""
        //     };
        //     this.addDishVisible = true;
        // },
        handleEditDish(row) {
            this.isEditDishMode = true;
            this.currentDishId = row.id;
            // 初始化时间范围（兼容后端返回的字符串/数组）
            const timeRange = Array.isArray(row.productTimeRange)
                ? row.productTimeRange
                : (row.productTime ? row.productTime.split('-') : []);

            this.dishForm = {
                orderNumber: this.currentOrder.orderNumber,
                productType: row.productType || "finished",
                dishName: "",
                dishCode: "",
                productName: row.productName || row.dishName,
                productCode: row.productCode || row.dishCode,
                productPrice: Number(row.productPrice) || 0,
                productTime: row.productTime || "",
                productTimeRange: timeRange, // 初始化时间范围
                productDescription: row.productDescription || ""
            };
            // 初始化时同步productTime
            this.formatDishProductTime();
            this.addDishVisible = true;
        },
        // 删除商品
        async handleDeleteDish(row) {
            try {
                await this.$confirm(
                    "确定要删除该商品吗？",
                    "提示",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }
                );
                const response = await delOrderItem({ id: row.id, orderId: this.currentOrder.id });
                if (response.code === 200) {
                    this.Listdish = this.Listdish.filter(item => item.id !== row.id);
                    this.updateOrderDishes();
                    this.$message.success("删除成功");
                } else {
                    this.$message.error(`删除失败：${response.message || "未知错误"}`);
                }
            } catch (error) {
                if (error !== "cancel") {
                    console.error("删除商品失败:", error);
                    this.$message.error("网络错误，删除失败");
                }
            }
        },

        // 商品弹窗-菜品类型变更
        handleproductTypeChange() {
            this.currentDishName = "";
            this.currentDishCode = "";
            this.dishForm.productPrice = 0;
            this.dishForm.productTime = "";
            this.dishForm.productTimeRange = [];
        },

        // 商品弹窗-选择菜品后自动填充编码和价格（优化版）
        handleDishSelect() {
            const dishList = this.getDishListByType(this.dishForm.productType);
            const keyName = this.isEditDishMode ? 'productName' : 'dishName';
            const keyCode = this.isEditDishMode ? 'productCode' : 'dishCode';

            const selectedDish = dishList.find(d =>
                d[keyName].trim() === this.currentDishName.trim()
            );

            if (selectedDish) {
                this.currentDishCode = selectedDish[keyCode];
                this.dishForm.productPrice = selectedDish.price;
            } else {
                this.$message.warning(`未找到【${this.currentDishName}】的编码信息`);
            }
        },

        // 格式化商品弹窗的生产时间（将时间范围转为"06:00-08:00"格式）
        // formatDishProductTime() {
        //     if (Array.isArray(this.dishForm.productTimeRange) && this.dishForm.productTimeRange.length === 2) {
        //         this.dishForm.productTime = `${this.dishForm.productTimeRange[0]}-${this.dishForm.productTimeRange[1]}`;
        //     } else {
        //         this.dishForm.productTime = "";
        //     }
        // },
        // 格式化商品弹窗的生产时间（将时间范围转为"06:00-08:00"格式）
        formatDishProductTime() {
            // 空值保护：确保是数组且有2个值
            if (Array.isArray(this.dishForm.productTimeRange) && this.dishForm.productTimeRange.length === 2) {
                // 响应式更新productTime（解决Vue无法检测对象属性新增/修改的问题）
                this.$set(this.dishForm, 'productTime', `${this.dishForm.productTimeRange[0]}-${this.dishForm.productTimeRange[1]}`);
            } else {
                // 清空无效值
                this.$set(this.dishForm, 'productTime', '');
            }
        },
        // 提交商品表单
        async submitDishForm() {
            // 先格式化生产时间
            this.formatDishProductTime();

            try {
                await this.$refs.dishFormRef.validate();

                // 构造提交数据
                const submitData = {
                    orderId: this.currentOrder.id,
                    productType: this.dishForm.productType,
                    productPrice: this.dishForm.productPrice,
                    productTime: this.dishForm.productTime, // 传给后端的格式："06:00-08:00"
                    productDescription: this.dishForm.productDescription
                };

                // 差异化传参
                if (this.isEditDishMode) {
                    submitData.productName = this.dishForm.productName;
                    submitData.productCode = this.dishForm.productCode;
                } else {
                    submitData.dishName = this.dishForm.dishName;
                    submitData.dishCode = this.dishForm.dishCode;
                }

                if (this.isEditDishMode) {
                    // 编辑商品
                    const response = await editOrderItem({
                        id: this.currentDishId,
                        ...submitData
                    });
                    if (response.code === 200) {
                        const index = this.Listdish.findIndex(item => item.id === this.currentDishId);
                        if (index !== -1) {
                            this.Listdish[index] = {
                                ...this.Listdish[index],
                                productName: this.dishForm.productName,
                                productCode: this.dishForm.productCode,
                                productPrice: this.dishForm.productPrice,
                                productTime: this.dishForm.productTime,
                                productTimeRange: this.dishForm.productTimeRange,
                                productDescription: this.dishForm.productDescription
                            };
                        }
                        this.$message.success("更新成功");
                    } else {
                        this.$message.error(`更新失败：${response.message || "未知错误"}`);
                        return;
                    }
                } else {
                    // 新增商品
                    const response = await addOrderItem(submitData);
                    if (response.code === 200) {
                        this.Listdish.push({
                            id: response.data.id,
                            orderNumber: this.dishForm.orderNumber,
                            productType: this.dishForm.productType,
                            dishName: this.dishForm.dishName,
                            dishCode: this.dishForm.dishCode,
                            productName: "",
                            productCode: "",
                            productPrice: this.dishForm.productPrice,
                            productTime: this.dishForm.productTime,
                            productTimeRange: this.dishForm.productTimeRange,
                            productDescription: this.dishForm.productDescription
                        });
                        this.$message.success("新增成功");
                    } else {
                        this.$message.error(`新增失败：${response.message || "未知错误"}`);
                        return;
                    }
                }
                this.updateOrderDishes();
                this.addDishVisible = false;
            } catch (error) {
                if (error !== "validation") {
                    console.error("商品操作失败:", error);
                    this.$message.error("网络错误，操作失败");
                }
            }
        },

        // 同步更新订单的菜品数据
        updateOrderDishes() {
            const orderIndex = this.allOrders.findIndex(order => order.id === this.currentOrder.id);
            if (orderIndex !== -1) {
                this.allOrders[orderIndex].orderItems = this.Listdish.map(dish => ({
                    productType: dish.productType,
                    dishName: dish.dishName,
                    dishCode: dish.dishCode,
                    productName: dish.productName || dish.dishName,
                    productCode: dish.productCode || dish.dishCode,
                    quantity: 1,
                    productPrice: dish.productPrice,
                    productTime: dish.productTime,
                    productTimeRange: dish.productTimeRange,
                    productDescription: dish.productDescription || ""
                }));
                this.allOrders[orderIndex].totalAmount = this.Listdish.reduce(
                    (sum, dish) => sum + Number(dish.productPrice), 0
                );
                this.filterOrders();
            }
        },

        // 添加菜品
        addDish() {
            // 获取默认菜品数据
            const defaultDish = this.dishLibrary.finished[0] || {};
            this.internalOrderForm.orderItems.push({
                productType: "finished",
                productName: defaultDish.productName || "",
                productCode: defaultDish.productCode || "",
                quantity: 1,
                productPrice: defaultDish.price || 0,
                productTime: "00:00-01:00",
                productTimeRange: ["00:00", "01:00"],
                productDescription: ""
            });
            this.calculateTotalAmount();
        },

        // 移除菜品
        removeDish(index) {
            if (this.internalOrderForm.orderItems.length <= 1) {
                this.$message.warning("至少保留一道菜品");
                return;
            }
            this.internalOrderForm.orderItems.splice(index, 1);
            this.calculateTotalAmount();
        },

        // 订单明细-菜品类型变更
        handleOrderproductTypeChange(row) {
            const defaultDish = this.getDishListByType(row.productType)[0] || {};
            this.$set(row, "productName", defaultDish.productName || "");
            this.$set(row, "productCode", defaultDish.productCode || "");
            this.$set(row, "productPrice", defaultDish.price || 0);
            this.$set(row, "productTime", "00:00-01:00");
            this.$set(row, "productTimeRange", ["00:00", "01:00"]);
            this.calculateTotalAmount();
        },

        // 订单明细-选择菜品后自动填充编码和价格
        handleOrderDishSelect(row) {
            const dishList = this.getDishListByType(row.productType);
            const selectedDish = dishList.find(d =>
                d.productName.trim() === row.productName.trim()
            );
            if (selectedDish) {
                this.$set(row, "productCode", selectedDish.productCode);
                this.$set(row, "productPrice", selectedDish.price);
            } else {
                this.$message.warning(`未找到【${row.productName}】的编码和价格信息`);
                this.$set(row, "productCode", "");
                this.$set(row, "productPrice", 0);
            }
            this.calculateTotalAmount();
        },

        // 订单明细-格式化生产时间（核心修复：空值保护 + 响应式更新）
        formatOrderItemProductTime(row) {
            // 增加空值判断：先确保 productTimeRange 是数组，再判断长度
            if (Array.isArray(row.productTimeRange) && row.productTimeRange.length === 2) {
                this.$set(row, 'productTime', `${row.productTimeRange[0]}-${row.productTimeRange[1]}`);
            } else {
                // 空值时设置默认时间段
                this.$set(row, 'productTime', "00:00-01:00");
                this.$set(row, 'productTimeRange', ["00:00", "01:00"]);
            }
        },

        // 根据菜品类型获取菜品列表
        getDishListByType(type) {
            return type === "finished" ? this.dishLibrary.finished : this.dishLibrary.semi;
        },

        // 计算总价格
        calculateTotalAmount() {
            let total = 0;
            this.internalOrderForm.orderItems.forEach(dish => {
                total += (Number(dish.productPrice) || 0) * (Number(dish.quantity) || 1);
            });
            this.internalOrderForm.totalAmount = total;
        },

        // 提交订单
        async submitInternalOrder() {
            // 先格式化所有订单明细的生产时间
            this.internalOrderForm.orderItems.forEach(row => {
                this.formatOrderItemProductTime(row);
            });

            try {
                await this.$refs.internalOrderRef.validate();

                // 优化校验：仅当菜品字段为空且非默认值时提示
                const hasEmptyDish = this.internalOrderForm.orderItems.some(dish => {
                    // 排除默认值情况
                    const isDefaultTime = dish.productTime === "00:00-01:00";
                    const isDefaultPrice = dish.productPrice === 0 && !dish.productName;
                    return !isDefaultTime && !isDefaultPrice &&
                        (!dish.productType || !dish.productName || !dish.productPrice || !dish.quantity || !dish.productTime);
                });

                if (hasEmptyDish) {
                    this.$message.error("请完善所有菜品信息（类型、名称、价格、数量、生产时间不能为空）");
                    return;
                }

                const orderData = {
                    ...this.internalOrderForm,
                    orderTime: this.formatDateForApi(this.internalOrderForm.orderTime),
                    outboundTime: this.internalOrderForm.outboundTime
                        ? this.formatDateForApi(this.internalOrderForm.outboundTime)
                        : null,
                    harvestDate: this.internalOrderForm.harvestDate
                        ? this.formatDateForApi(this.internalOrderForm.harvestDate)
                        : null,
                    orderStatus: Number(this.internalOrderForm.orderStatus)
                };

                const response = this.isEditOrderMode
                    ? await edit(orderData)
                    : await add(orderData);

                if (response.code === 200) {
                    this.$message.success(this.isEditOrderMode ? "订单更新成功" : "订单创建成功");
                    this.createInternalOrderVisible = false;
                    this.fetchOrders();
                } else {
                    this.$message.error(`操作失败：${response.message || "未知错误"}`);
                }
            } catch (error) {
                if (error !== "validation") {
                    console.error("提交订单失败:", error);
                    this.$message.error("网络错误，操作失败");
                }
            }
        },

        // 出库状态变更
        handleOutboundStatusChange(status) {
            if (status !== "completed") {
                this.internalOrderForm.outboundTime = null;
            }
        },

        // 格式化工具
        formatDate(date) {
            return date.toLocaleString("zh-CN", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit"
            });
        },
        formatDateForApi(date) {
            return date.toISOString().slice(0, 19).replace("T", " ");
        },
        formatDateFororderNumber(date) {
            return `${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, "0")}${String(date.getDate()).padStart(2, "0")}`;
        },
        formatOrderType(type) {
            const typeMap = {
                零散: "零散",
                小程序订单: "活动餐",
                内部订单: "内部订单",
                test: "测试订单"
            };
            return typeMap[type] || type;
        },
        formatPickupMethod(method) {
            const methodMap = {
                selfPickup: "上门自提",
                internalDelivery: "配送"
            };
            if (!methodMap[method]) {
                console.warn("未匹配的取货方式：", method);
            }
            return methodMap[method] || "未知方式";
        },
        getStatusTagType1(method) {
            const typeMap = {
                selfPickup: "primary",
                internalDelivery: "success"
            };
            return typeMap[method] || "default";
        },

        // 分页事件
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.filterOrders();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.filterOrders();
        },

        // 表格行点击
        handleRowClick(row) {
            this.$refs.orderTable?.toggleRowSelection(row);
        },
        handleDishRowClick(row) {
            this.$refs.supplierTable?.toggleRowSelection(row);
        },

        // 标签页切换
        handleSubTabChange() {
            this.currentPage = 1;
            this.fetchOrders();
        }
    }
};
</script>

<style lang="scss" scoped>
.order-management {
    padding: 20px;
    // background-color: #f5f7fa;
    min-height: 100vh;
}

.sub-tabs {
    margin-bottom: 15px;
}

.filter-card {
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.filter-form {
    padding: 15px 0;

    .el-form-item {
        margin-right: 15px;
        margin-bottom: 10px;
    }
}

.order-list-card {
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    height: 70vh;

    .el-table {
        margin-bottom: 15px;
    }
}

.pagination-container {
    text-align: right;
    padding: 10px 0;
}

.order-detail {
    font-size: 14px;

    .detail-header {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        margin-bottom: 20px;
        padding-bottom: 15px;
        border-bottom: 1px solid #eee;

        .order-info,
        .customer-info {
            flex: 1;
            min-width: 300px;

            p {
                margin: 8px 0;
            }
        }
    }

    .detail-body {
        margin-bottom: 20px;

        h3 {
            margin: 0 0 10px 0;
            font-size: 16px;
            color: #333;
            font-weight: 500;
        }
    }

    .detail-footer {
        padding-top: 15px;
        border-top: 1px solid #eee;

        .order-notes p {
            margin: 8px 0;
        }
    }
}

::v-deep .el-tag {
    margin-right: 0;
}

::v-deep .detail-drawer .el-drawer__body {
    padding: 20px;
    overflow: auto;
}

.text-danger {
    color: #f56c6c;
}
</style>